import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { ArticleDto } from '../models/dto/article-dto';
import { ArticleListItemDto } from '../models/dto/article-list-item-dto';
import { SearchResultCounts } from '../models/search-result-counts';
import {
    articleDetailsLoaded,
    articleDetailsReset,
    articleSearchResultReceived,
    articleSearchResultReset,
    articleSearchTermChange,
    articleSpecialOffersReceived,
    initialArticleSearchResultReceived,
} from './articles-actions';

export interface ArticlesState {
    articleSpecialOffers: PaginatedResponse<ArticleListItemDto>;
    articleSearchResults: PaginatedResponse<ArticleListItemDto, SearchResultCounts>;
    initialArticleSearchResults: PaginatedResponse<ArticleListItemDto, SearchResultCounts>;
    articleDetail?: ArticleDto;
    articleSearchTerm: string;
}

const initialState: ArticlesState = {
    articleSpecialOffers: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
    articleSearchResults: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
    initialArticleSearchResults: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
    articleSearchTerm: '',
};

export const articlesReducer = createReducer(initialState, builder => {
    builder.addCase(articleSpecialOffersReceived, (state, action) => ({
        ...state,
        articleSpecialOffers: {
            ...action.payload,
            items:
                action.payload.page === 1
                    ? action.payload.items
                    : [...state.articleSpecialOffers.items, ...action.payload.items],
        },
    }));
    builder.addCase(articleSearchResultReceived, (state, action) => ({
        ...state,
        articleSearchResults: action.payload,
    }));
    builder.addCase(initialArticleSearchResultReceived, (state, action) => ({
        ...state,
        initialArticleSearchResults: action.payload,
    }));
    builder.addCase(articleSearchResultReset, state => ({
        ...state,
        articleSearchResults: initialState.articleSearchResults,
    }));
    builder.addCase(articleDetailsLoaded, (state, action) => ({
        ...state,
        articleDetail: action.payload,
    }));
    builder.addCase(articleDetailsReset, state => ({
        ...state,
        articleDetail: initialState.articleDetail,
    }));
    builder.addCase(articleSearchTermChange, (state, action) => ({
        ...state,
        articleSearchTerm: action.payload,
    }));
});
